// extracted by mini-css-extract-plugin
export var icon = "_4t-1";
export var subtext = "_4t-0";